import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import Float from "../../ui/Float";
import Space from "../../ui/Space";
import Button from "../../ui/Button";
import { kbdEvent, stringToFile } from "../../utils/Utils";
import { showError, showMessage } from "../../ui/Message";
import { pubCall } from "../../utils/PubSub";
import Spin from "../../ui/Spin"
import Menu from "../../ui/Menu";
import ViewFile from "./ViewFile";
import { ROUTES } from "../../utils/Routes";
import { createModal } from "../../hooks/createModal";

export default function ImportCounts(props) {


    const { callback = () => { }, route = "", filters = {} } = props;

    const [selected, setSelected] = useState("V");

    const ref = useRef();
    const uploadRef = useRef();
    const [filename, setFilename] = useState("");
    const [loading, setLoading] = useState(false);
    const [uploaded, setUploaded] = useState({
        uploaded: false,
        text: "",
        file_name: ""
    });

    const exportToTextFile = () => {

        if (!filename) {
            showError({ error: "Must have a filename" })
            return;
        }

        setLoading(true);
        pubCall("reconciliation.export", { filter: filters?.oh_filter || false }, (_status, _result) => {
            if (_status) {
                stringToFile(filename, _result.result);
                callback(false);
            } else {
                showError(_result);
            }
            setLoading(false);
        })
    }


    const handleFile = (e) => {

        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            setUploaded({
                uploaded: true,
                text: text,
                file_name: file.name
            })
        };
        reader.onerror = (event) => {
            showError({ error: "File could not be read!" });
        };

        reader.readAsText(file);
    }

    useEffect(() => {
        if (ref?.current) {
            ref.current.focus();
        }
        const actions = [
            {
                key: KBD.ENTER, action: (e) => {
                    if (!uploaded.uploaded) {
                        uploadRef?.current.click()
                    } else {
                        switch(selected){
                            case "V" :
                                viewFile()
                            break; 
                            case "P" :
                                importFile()
                            break; 
                            case "R" :
                                importFile(true)
                            break; 
                        }
                    }
                }
            },
            {
                key: KBD.ESCAPE, action: (e) => {
                    if (!uploaded.uploaded) {
                        callback(false)
                    } else {
                        setUploaded({
                            uploaded: false,
                            text: "",
                            file_name: ""
                        })
                    }
                }
            },
            {
                key: KBD.PAGE_UP, action: (e) => {
                    if (!uploaded.uploaded) {
                        uploadRef?.current.click()
                    }
                }
            }
        ];
        const cleanup = listen(route, actions, (e) => { }, [KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [filename, uploadRef, uploaded, selected]);


    const viewFile = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.VIEW_FILE;
        createModal({
            component: <ViewFile text={uploaded.text} route={ROUTES.RECONCILIATION.VIEW_FILE} />, title: "Import file", closable: true, callback: (_r) => {
                if (_r) {
                  
                }
                window.bm_state.value = route;
            }
        })
    }

    const importFile = (_reverse = false) => {
        let _obj = {
            csv_string: uploaded.text,
            negate: _reverse,
        }

        pubCall("reconciliation.import", _obj, (_status, _result) => {
            if (_status) {
                showMessage("File imported successfully.");
                callback(true); 
            } else {
                showError(_result);
            }
        })
    }


    const menu = [
        { text: "View the file", option: "V" },
        { text: "Process as is", option: "P" },
        { text: <>Reverse quantities <small style={{ "opacity": "0.6", "fontSize": "14px" }}><em>e.g. undo the previous import of this file</em></small></>, option: "R" },
    ]

   

    const drawUpload = () => {

        return (
            <Spin loading={loading}>
                <div style={{ "width": "450px" }}>
                    <div className="shim" /><div className="shim" />
                    <Label style={{ "textAlign": "left" }} width={350}>Filename:</Label>
                    <div className="shim" />
                    <Input ref={ref} edit controlled maxLength={40} placeholder="Select file..." autoselect width={440} value={filename} />
                    <input accept=".csv" onChange={(e) => handleFile(e)} ref={uploadRef} type="file" style={{ "height": "0px", "opacity": "0", "width": "0px" }} />
                    <div className="shim" />
                    <Label style={{ "textAlign": "left" }}>File with tab or comma separated Qty and ISBNs (or ISBNs only)</Label>
                    <div className="shim" /> <div className="shim" /> <div className="shim" />
                    <Label style={{ "textAlign": "left" }}>Example:
                    </Label>
                    <div className="shim" />
                    <Space><div style={{ "width": "20px" }}>&nbsp;</div><Label>2,9780123456789 - Qty and EAN/ISBN/UPC</Label></Space>
                    <Space><div style={{ "width": "20px" }}>&nbsp;</div><Label>9780123456789 - EAN only (qty assumed to be 1)</Label></Space>
                    <div className="shim" /><div className="shim" /> <div className="shim" />
                    <Float>
                        <div></div>
                        <Space>
                            <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)} >Cancel</Button>
                            <Button kbd={KBD.PAGE_UP} onClick={() => kbdEvent(KBD.PAGE_UP)} type="secondary">Import</Button>
                        </Space>
                    </Float>
                </div>
            </Spin>

        )
    }

    const drawOptions = () => {
        return (
            <Spin loading={loading}>
                <div style={{ "width": "450px" }}>
                    <div className="shim" /><div className="shim" />
                    <Menu callback={(e) => {
                        switch(e.option){
                            case "V" :
                                viewFile()
                            break; 
                            case "P" :
                                importFile()
                            break; 
                            case "R" :
                                importFile(true)
                            break; 
                        }
                    }} bordered keyName="option" setSelected={setSelected} selected={selected} menu={menu} route={route} />
                    <div className="shim" /><div className="shim" /> <div className="shim" />
                    <Float>
                        <div></div>
                        <Space>
                            <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)} >Back</Button>
                            
                        </Space>
                    </Float>
                </div>
            </Spin>
        )
    }


    return (uploaded.uploaded) ? drawOptions() : drawUpload();

}